import {
    Component,
    inject,
    OnInit
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { restManager } from 'app/ajs-upgraded-providers';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Form } from 'src/app/models';
import { ErrorsLoggerService } from 'src/app/core';

type EditPinFormFields = {
    pin: string | null;
}
type EditPinFormFieldsNullable = {
    [prop in string & keyof EditPinFormFields]:EditPinFormFields[prop]|null
}
type EditPinForm = Partial<Form<EditPinFormFieldsNullable>>;

type EditPinPayload = {
    first_name: string;
    last_name: string;
    pin: string | null;
}

@Component({
	standalone: false,
  selector: 'app-edit-pin-dialog',
  templateUrl: './edit-pin-dialog.component.html',
})
export class EditPinDialogComponent implements OnInit {
    public readonly dialogRef: MatDialogRef<EditPinPayload> = inject(MatDialogRef);
    public readonly data: EditPinPayload = inject(MAT_DIALOG_DATA);
    private readonly restManagerService = inject(restManager);
    private readonly errorsLoggerService = inject(ErrorsLoggerService);
    private readonly translate = inject(TranslateService);

    editPinDialogForm: FormGroup<{pin?:FormControl<string|null>}>;
    errorPin: boolean;
    errorPinMessage: string;
    inProgress: boolean;

    constructor(
    ) {
        this.editPinDialogForm = new FormGroup<EditPinForm>({
            pin: new FormControl(this.data.pin || null, [Validators.minLength(4), Validators.maxLength(4), Validators.pattern('^[0-9]*$')])
        });
        this.errorPin = false;
        this.errorPinMessage = '';
        this.inProgress = false;
    }
    ngOnInit(): void {

    }
    get pin(){
        return this.editPinDialogForm.controls.pin;
    }

    confirm(): void {
        this.inProgress = true;
        this.errorPin = false;
        const payload: EditPinPayload = this.data;
        payload.pin = this.pin?.value || null;
        this.restManagerService.post('sessions/current_user', payload).then((res: any) => {
            if(res) {
                this.dialogRef.close(res);
            }
        }).catch((res: any) => {
            this.errorsLoggerService.err('POST sessions/current_user', res);
            if (res && res.status === 422) {
                this.errorPinMessage = res.data.message;
                this.errorPin = true;
                if(res.data.type === 'input') {
                    this.errorPinMessage = this.translate.instant('SETTINGS.EDIT_USER_ACEESS_DIALOG.INVALID_PIN_INPUT');
                }
            }
        }).finally(() => {
            this.inProgress = false;
        });
    }
}
